import { useEffect } from 'react';
import { recordGameVisit } from '@/apis/casino/games';
import { useAtomValue } from 'jotai/index';
import { gameListSelector } from '@/state/globalSettings';
import queryClient from '@/reactQueryKeys/queryClient';
import queryKeysFactory from '@/reactQueryKeys/keysFactory';
import { userInfoState } from '@/state/userInfo';
import useFindMatchingGame from './casino/useFindMatchingGame';

const useRecordRecentPlayed = (game: { gameId: string }) => {
  const { list } = useAtomValue(gameListSelector);

  const { isUserLoading, userMetaData } = useAtomValue(userInfoState);

  const matchingGame = useFindMatchingGame(game.gameId);

  useEffect(() => {
    if (isUserLoading || !userMetaData?.token || !list.length || !matchingGame)
      return;
    recordGameVisit(matchingGame?.gameId, matchingGame?.provider);
    return () => {
      queryClient.invalidateQueries(
        queryKeysFactory.casino.queryUserFootprint(),
      );
    };
  }, [game.gameId, matchingGame?.provider, isUserLoading, userMetaData, list]);
};

export default useRecordRecentPlayed;
